import { useState } from "react";
import "../../styles/viewerSetting.css";

const SETTINGS = [
  { key: "halfPageReporting",   label: "Enable half page reporting"       },
  { key: "voiceTypingAuto",     label: "Enable Voice typing in editor auto" },
  { key: "openInNewWindow",     label: "Open viewer in new window"        },
  { key: "doNotFocusNewWindow", label: "Do not focus on new window"       },
  { key: "hideReportButton",    label: "Hide report button in study list" },
];

export default function ViewerSetting({ isOpen, onClose, onSubmit }) {
  const [toggles, setToggles] = useState({
    halfPageReporting:   false,
    voiceTypingAuto:     true,   
    openInNewWindow:     false,
    doNotFocusNewWindow: false,
    hideReportButton:    false,
  });
  if (!isOpen) return null;
  function handleToggle(key) {
    setToggles((prev) => ({ ...prev, [key]: !prev[key] }));
  }
  function handleSubmit() {
    onSubmit?.(toggles);
    onClose?.();
  }
  function handleBackdrop(e) {
    if (e.target === e.currentTarget) onClose?.();
  }
  return (
    <div className="vs-backdrop" onMouseDown={handleBackdrop}>
      <div className="vs-modal">
        {/* Title */}
        <h2 className="vs-title">Viewer setting</h2>
        {/* Subtitle */}
        <p className="vs-subtitle">Setting to customize user interface</p>
        {/* Toggle rows */}
        <div className="vs-settings-list">
          {SETTINGS.map(({ key, label }) => (
            <div key={key} className="vs-setting-row">
              <span className="vs-setting-label">{label}</span>
              <div
                className={`vs-toggle ${toggles[key] ? "vs-toggle--on" : ""}`}
                onClick={() => handleToggle(key)}
                role="switch"
                aria-checked={toggles[key]}
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && handleToggle(key)}
              >
                <div className="vs-toggle-thumb" />
              </div>
            </div>
          ))}
        </div>
        {/* Submit */}
        <button className="vs-submit-btn" onClick={handleSubmit}>
          SUBMIT
        </button>
        {/* Close */}
        <div className="vs-close-row">
          <button className="vs-close-btn" onClick={onClose}>CLOSE</button>
        </div>
      </div>
    </div>
  );
}